import React, { useState, useEffect } from "react";
import { FaInstagram, FaBars, FaTimes, FaTiktok, FaYoutube, FaFacebook } from "react-icons/fa";

const Header = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="sticky top-0 bg-white dark:bg-gray-900 shadow-md z-50">
      <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center space-x-4">
          <h1 className="text-2xl font-bold text-brandcolour">HaZe IT Solutions</h1>
        </div>

        {/* Hamburger Menu Button */}
        <div className="md:hidden text-brandcolour">
          <button onClick={toggleMenu} aria-label="Toggle Menu">
            <FaBars size={24} />
          </button>
        </div>

        {/* Navigation Links for Desktop */}
        <ul className="hidden md:flex space-x-6 text-gray-700 dark:text-gray-300">
          <li>
            <a href="/" className="hover:text-brandcolour">
              Home
            </a>
          </li>
          <li>
            <a href="/about" className="hover:text-brandcolour">
              About
            </a>
          </li>
          <li>
            <a href="/services" className="hover:text-brandcolour">
              Services
            </a>
          </li>
          <li>
            <a href="/contact" className="hover:text-brandcolour">
              Contact
            </a>
          </li>
        </ul>

        {/* Social Links and Theme Toggle for Desktop */}
        <div className="hidden md:flex items-center space-x-4">
          <a
            href="https://www.instagram.com/haze_itsolutions/?utm_source=qr#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on Instagram"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.tiktok.com/@hazeitsolutions?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on TikTok"
          >
            <FaTiktok size={24} />
          </a>
          <a 
            href="https://www.youtube.com/channel/UCq8nwanFzFSTGLXUINb7JWA"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on YouTube"
          >
            <FaYoutube size={24} />
          </a>
          <button
            onClick={toggleTheme}
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded-lg shadow hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            {theme === "light" ? "🌙" : "☀️"}
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        {menuOpen && (
          <div className="fixed inset-0 bg-white dark:bg-gray-900 z-40 flex flex-col items-center space-y-8 pt-20 text-gray-700 dark:text-gray-300">
            {/* Close Button */}
            <button
              onClick={toggleMenu}
              aria-label="Close Menu"
              className="absolute top-5 right-5 text-gray-700 dark:text-gray-300"
            >
              <FaTimes size={30} />
            </button>

            <ul className="flex flex-col items-center space-y-6">
              <li>
                <a
                  href="/"
                  className="hover:text-brandcolour"
                  onClick={toggleMenu}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="hover:text-brandcolour"
                  onClick={toggleMenu}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="hover:text-brandcolour"
                  onClick={toggleMenu}
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="hover:text-brandcolour"
                  onClick={toggleMenu}
                >
                  Contact
                </a>
              </li>
            </ul>

            {/* Social Links and Theme Toggle */}
            <div className="mt-auto mb-10 flex items-center space-x-4">
            <a
            href="https://www.instagram.com/haze_itsolutions/?utm_source=qr#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on Instagram"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.tiktok.com/@hazeitsolutions?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on TikTok"
          >
            <FaTiktok size={24} />
          </a>
          <a 
            href="https://www.youtube.com/channel/UCq8nwanFzFSTGLXUINb7JWA"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on YouTube"
          >
            <FaYoutube size={24} />
          </a>
              <button
                onClick={toggleTheme}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded-lg shadow hover:bg-gray-300 dark:hover:bg-gray-600 transition"
              >
                {theme === "light" ? "🌙" : "☀️"}
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
